module.exports = __webpack_public_path__ + "img/outer-7.4ddac978.png";